<template>
  <v-container fluid fill-height class="login-bg">
    <v-layout>
      <v-container>
        <v-layout class="justify-center">
          <v-flex md4 xl3>
            <v-card style="padding: 48px 0 0;">
              <div style="padding: 0 32px; text-align: center;">
                <img
                  style="width: 100%; max-width: 350px; margin: 0 auto 48px;"
                  src="/static/img/logo.png"
                />
              </div>

              <v-card-text style="padding: 32px 32px 0;">
                <form>
                  <v-text-field
                    :class="{ 'input-group--dirty': dirtyLogin }"
                    v-model="login"
                    label="Логин"
                    required
                    :rules="[() => login.length > 0 || 'Это поле обязательно к заполнению']"
                    @keyup.enter="Ulogin"
                  ></v-text-field>
                  <v-text-field
                    :class="{ 'input-group--dirty': dirtyPass }"
                    v-model="pass"
                    required
                    label="Пароль"
                    :rules="[() => pass.length > 0 || 'Это поле обязательно к заполнению']"
                    :append-icon="!passVisible ? 'visibility' : 'visibility_off'"
                    @click:append="() => (passVisible = !passVisible)"
                    :type="!passVisible ? 'password' : 'text'"
                    @keyup.enter="Ulogin"
                  ></v-text-field>
                  <div class="m-20"></div>
                  <div class="text-md-center" style="padding-top: 16px;">
                    <v-btn block style="background-color: #ee7f1a;" dark @click="Ulogin">Войти</v-btn>
                  </div>
                  <div class="m-20"></div>
                </form>
              </v-card-text>
              <v-progress-linear
                class="loader-w-m"
                height="3"
                color="blue"
                :active="inProgress"
                :indeterminate="true"
              ></v-progress-linear>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
export default {
  data() {
    return {
      pass: '',
      login: '',
      dirtyPass: null,
      dirtyLogin: null,
      passVisible: false,
      inProgress: false,
    }
  },
  methods: {
    async Ulogin() {
      this.inProgress = true
      await store.dispatch('login', { login: this.login, password: this.pass })
      this.inProgress = false
    },
  },
  mounted() {
    let times = 0
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyLogin && this.dirtyPass) || times === 20) {
        clearInterval(interval)
      }
      this.dirtyLogin = document.querySelector('input[type="text"]:-webkit-autofill')
      this.dirtyPass = document.querySelector('input[type="password"]:-webkit-autofill')
    }, 100)
  },
}
</script>

<style scoped>
.login-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>